export const STORAGE = '@PosLocacoes';
export const PAGE_SIZE = 10;
export const PAGE_SIZE_SINISTER = 40;
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA;
export const ENABLE_RECAPTCHA =
  process.env.REACT_APP_ENABLE_RECAPTCHA === 'true';
export const ALL_FEATURES = true;
export const PRIVACY_POLICY_URL =
  'https://privacidade.positivotecnologia.com.br/';

export const ROUTER_PATHS = {
  LOGIN: '/login',
  SAML_LOGIN: `/sso/signin`,
  FORGOT_PASSWORD: '/forgot-password',
  AUTHENTICATOR: '/authenticator',
  FORGOT_PASSWORD_TOKEN: '/recovery-password/:token',
  EXPIRED_PASSWORD: '/recovery-password/:token/expired',
  VERIFY_CODE: '/verify-code',
  CREATE_PASSWORD: '/create-password',
  LOGOUT: '/logout',
  VIEW_LETTER: '/view-letter/:groupId',
  PORTAL: {
    HOME: '/portal',
    CONTRACTS: '/portal/contracts',
    CONCTRACT_DETAIL: '/portal/contracts/:id',
    CONTRACT_EXTENSION: '/portal/contracts-extension/:id',
    INVOICES: '/portal/invoices',
    INVOICES_DETAIL: '/portal/invoices/:id',
    DOCUMENTS: '/portal/documents',
    SINISTERS: '/portal/sinisters',
    SINISTERS_DETAIL: '/portal/sinisters/:id',
    BASE: '/portal/installed-base',
    OCCURRENCES: '/portal/occurrences',
    OCCURRENCE_DETAIL: '/portal/occurrences/:id',
    NEW_OCCURRENCE: '/portal/occurrences/new-occurrence',
    BUSINESS_INFORMATION: '/portal/business-information',
    CONTRACT_MEASUREMENT: '/portal/contract-measurement',
    PROFILE: '/portal/profile',
    EMAILS: '/portal/emails',
    CONTACT: '/portal/contact-us',
    TECHNICAL_SUPPORT: '/portal/technical-support',
    ANNOUNCEMENTS: '/portal/announcements',
    INSURANCE: '/portal/insurance',
    POWERBI_REPORT: '/portal/report/:id',
    STRATEGIC_MAP: '/portal/strategic-map',
    REQUEST_CONTRACT_TERMINATION: '/portal/request-contract-termination',
    REQUEST_CONTRACT_TERMINATION_LIST:
      '/portal/request-contract-termination-list',
    ADMIN: {
      BASE: '/portal/admin',
      USERS: '/portal/admin/users',
      USERS_FORM: '/portal/admin/users/form',
      GROUPS: '/portal/admin/groups',
      GROUPS_FORM: '/portal/admin/groups/form',
      COMPANIES: '/portal/admin/companies',
      COMPANY_DETAIL: '/portal/admin/companies/:companyId',
      COMPANY_FORM: '/portal/admin/companies/form/:companyId',
      EQUIPMENTS: '/portal/admin/equipments',
      EQUIPMENTS_FORM_EDIT: '/portal/admin/equipments/form/:id',
      EQUIPMENTS_FORM: '/portal/admin/equipments/form',
      EQUIPMENT_TYPES: '/portal/admin/equipments/types',
      EQUIPMENT_MODELS: '/portal/admin/equipments/models',
      ACCESS_REPORTS: '/portal/admin/access-reports',
      ACCESS_REPORTS_DETAIL: '/portal/admin/access-reports/:userId',
      RESET_CACHE: '/portal/admin/reset-cache',
      JSON: '/portal/admin/json',
      DISCOUNT: '/portal/admin/discount',
      NON_PAYMENT: '/portal/admin/non_payment',
      ANNOUNCEMENTS: '/portal/admin/announcements',
      NEW_ANNOUNCEMENTS: '/portal/admin/announcements/new-announcements',
      ANNOUNCEMENTS_DETAIL: '/portal/admin/announcements-datail/:idComunicado',
      EDIT_ANNOUNCEMENTS:
        '/portal/admin/announcements/new-announcements/:id/edit',
      PRIVACYPOLICY: '/portal/admin/privacy-policy',
      PRIVACYPOLICY_DETAIL: '/portal/admin/privacy-policy/:id',
      NEW_PRIVACYPOLICY: '/portal/admin/privacy-policy/new-privacy-policy',
      EDIT_PRIVACYPOLICY:
        '/portal/admin/privacy-policy/new-privacy-policy/:id/edit',
      ZERO_CARBON_PROJECTS: '/portal/admin/zero-carbon-projects',
      ZERO_CARBON_CREATE_PROJECT: '/portal/admin/zero-carbon-projects/new',
      ZERO_CARBON_LETTERS: '/portal/admin/zero-carbon-letters',
      ZERO_CARBON_LETTERS_NEW: '/portal/admin/zero-carbon-letters/new',
      ZERO_CARBON_LETTERS_EDIT: '/portal/admin/zero-carbon-letters/:id',
      DASHBOARDS: '/portal/admin/dashboards',
      AUTOMATIC_ANALYSIS: '/portal/admin/automatic-analysis',
    },
  },
};
